"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIP = getIP;
function getIP() {
    return __awaiter(this, void 0, void 0, function () {
        var ip;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, secureBrowseIP()];
                case 1:
                    ip = _a.sent();
                    if (!!ip) return [3 /*break*/, 3];
                    return [4 /*yield*/, browseIP()];
                case 2:
                    ip = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, ip];
            }
        });
    });
}
function secureBrowseIP() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, getIpFromServers([new IpServer("https://ipapi.co/json/", 200, "ip")])];
        });
    });
}
function browseIP() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, getIpFromServers([
                    new IpServer("https://gd.geobytes.com/GetCityDetails", 200, "geobytesremoteip"),
                    new IpServer("https://www.geoplugin.net/json.gp", 200, "geoplugin_request"),
                ])];
        });
    });
}
function getIpFromServers(servers) {
    return __awaiter(this, void 0, void 0, function () {
        var _i, servers_1, server, response, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _i = 0, servers_1 = servers;
                    _a.label = 1;
                case 1:
                    if (!(_i < servers_1.length)) return [3 /*break*/, 8];
                    server = servers_1[_i];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 6, , 7]);
                    return [4 /*yield*/, fetch(server.getUrl())];
                case 3:
                    response = _a.sent();
                    if (!(response.status === server.getExpectedStatus())) return [3 /*break*/, 5];
                    return [4 /*yield*/, response.json()];
                case 4:
                    data = _a.sent();
                    if (data[server.getJsonAttribute()]) {
                        return [2 /*return*/, data[server.getJsonAttribute()]];
                    }
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_1 = _a.sent();
                    console.error("Error fetching from ".concat(server.getUrl(), ": "), error_1);
                    return [3 /*break*/, 7];
                case 7:
                    _i++;
                    return [3 /*break*/, 1];
                case 8: return [2 /*return*/, ""];
            }
        });
    });
}
var IpServer = /** @class */ (function () {
    function IpServer(url, expectedStatus, jsonAttribute) {
        this.url = url;
        this.expectedStatus = expectedStatus;
        this.jsonAttribute = jsonAttribute;
    }
    IpServer.prototype.getUrl = function () {
        return this.url;
    };
    IpServer.prototype.getExpectedStatus = function () {
        return this.expectedStatus;
    };
    IpServer.prototype.getJsonAttribute = function () {
        return this.jsonAttribute;
    };
    return IpServer;
}());
